var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wrapper",staticClass:"nut-hor-scroll"},[_c('div',{ref:"list",staticClass:"nut-hor-list"},[_vm._t("list"),_vm._v(" "),(_vm.$slots.more && _vm.isShowLoadMore)?_c('div',{staticClass:"nut-hor-control"},[_vm._t("more")],2):_vm._e(),_vm._v(" "),(_vm.$slots.arrow)?_vm._t("arrow"):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }